import {
  Layers,
  Sparkles,
  Cpu,
  Database,
  Zap,
  Link as LinkIcon,
  ShieldCheck,
} from "lucide-react";

/**
 * Nav data. Labels are keyed against `nav` namespace in /src/locales.
 * `hrefBase` is the canonical (English) href — components add the `/zh`
 * prefix when the current locale is Mandarin.
 *
 * Fallback English strings are kept alongside so that:
 *   1. Legacy consumers (`platformItems[i].label`) keep working.
 *   2. If i18n init failed, the English text still renders.
 */
export const platformItems = [
  {
    key: "stack",
    label: "The Frac Stack",
    desc: "Four layers. One asset class.",
    hrefBase: "/platform",
    href: "/platform",
    icon: Layers,
  },
  {
    key: "marketing",
    label: "01 · Marketing Technology",
    desc: "Automate the marketing. Keep the secrets.",
    hrefBase: "/platform/marketing",
    href: "/platform/marketing",
    icon: Sparkles,
  },
  {
    key: "ai",
    label: "02 · AI Infrastructure",
    desc: "Signal in. Structure out.",
    hrefBase: "/platform/ai",
    href: "/platform/ai",
    icon: Cpu,
  },
  {
    key: "data",
    label: "03 · Data Tokenization",
    desc: "One unit. One owner. One count.",
    hrefBase: "/platform/data",
    href: "/platform/data",
    icon: Database,
  },
  {
    key: "energy",
    label: "04 · Energy & Green Compute",
    desc: "Intelligence has a power bill.",
    hrefBase: "/platform/energy",
    href: "/platform/energy",
    icon: Zap,
  },
  {
    key: "terminal",
    label: "The Tokenization Terminal",
    desc: "The rails. Proven on the hard assets first.",
    hrefBase: "/platform/tokenization",
    href: "/platform/tokenization",
    icon: LinkIcon,
  },
];

export const solutionsItems = [
  {
    key: "consumer",
    label: "Consumer Brands & Retail",
    desc: "Loyalty, first-party data, categorization.",
    hrefBase: "/solutions#consumer-brands-retail",
    href: "/solutions#consumer-brands-retail",
  },
  {
    key: "luxury",
    label: "Luxury Assets",
    desc: "Provenance, resale trust, licensing.",
    hrefBase: "/solutions#luxury-assets",
    href: "/solutions#luxury-assets",
  },
  {
    key: "financial",
    label: "Financial Services",
    desc: "Behavioural intelligence for credit and risk.",
    hrefBase: "/solutions#financial-services",
    href: "/solutions#financial-services",
  },
  {
    key: "supply",
    label: "Supply Chain & Logistics",
    desc: "Anti-double-counting and chain-of-custody.",
    hrefBase: "/solutions#supply-chain-logistics",
    href: "/solutions#supply-chain-logistics",
  },
  {
    key: "energy",
    label: "Energy & Utilities",
    desc: "Metering, licensing, green compute.",
    hrefBase: "/solutions#energy-utilities",
    href: "/solutions#energy-utilities",
  },
  {
    key: "ngo",
    label: "NGO & Impact",
    desc: "Attribution and pseudonymized proof.",
    hrefBase: "/solutions#ngo-impact",
    href: "/solutions#ngo-impact",
  },
];

export const companyItems = [
  { key: "about", label: "About Frac", hrefBase: "/company#about", href: "/company#about" },
  { key: "leadership", label: "Leadership", hrefBase: "/company#leadership", href: "/company#leadership" },
  { key: "partners", label: "Partners & Ecosystem", hrefBase: "/company#partners", href: "/company#partners" },
  { key: "recognition", label: "Recognition", hrefBase: "/company#recognition", href: "/company#recognition" },
  // Added 2 Nov 2026: operator released Verified Documents from
  // preview-only / noindex gating. The route is now linked from the
  // Company mega-menu (last item) and the Resources footer column.
  {
    key: "verifiedDocs",
    label: "Verified Documents",
    desc: "Independently verifiable timestamp proofs for Frac publications.",
    hrefBase: "/verified-documents",
    href: "/verified-documents",
    icon: ShieldCheck,
  },
];

export const navGroups = [
  { id: "platform", label: "Platform", items: platformItems },
  { id: "intelligence", label: "Intelligence", hrefBase: "/intelligence", href: "/intelligence" },
  { id: "solutions", label: "Solutions", items: solutionsItems },
  { id: "company", label: "Company", items: companyItems },
  { id: "newsroom", label: "Newsroom", hrefBase: "/newsroom", href: "/newsroom" },
];

// Verified handles supplied by client 2026-02-18. No Instagram presence.
export const socialLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/frac-tional" },
  { label: "X", href: "https://twitter.com/frac_tional" },
  { label: "YouTube", href: "https://www.youtube.com/@frac_tional" },
];

export const offices = [
  {
    city: "Singapore",
    address:
      "8 Marina View, Asia Square Tower 1, #43-01, Singapore 018960",
  },
  {
    city: "Kuala Lumpur",
    address:
      "SO-21-1, Menara 1, Strata Office No.3, Jalan Bangsar, KL Eco City, 59200 Kuala Lumpur, Malaysia",
  },
];

export const contactEmails = [
  { label: "General", email: "hello@frac.io" },
  { label: "Partnerships", email: "partnerships@frac.io" },
  { label: "Media", email: "media@frac.io" },
];
